module.exports = __webpack_public_path__ + "img/title-4.94808d64.png";